import { render, staticRenderFns } from "./SupplementTutorReviewModal.vue?vue&type=template&id=c4254372&scoped=true"
import script from "./SupplementTutorReviewModal.vue?vue&type=script&lang=js"
export * from "./SupplementTutorReviewModal.vue?vue&type=script&lang=js"
import style0 from "./SupplementTutorReviewModal.vue?vue&type=style&index=0&id=c4254372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4254372",
  null
  
)

export default component.exports